export default {
  path: 'candled-rack-eggs',
  name: 'incubators.candled-rack-eggs',
  component: () => import('@/views/admin/incubators/candled-rack-eggs/Index'),
}